// The way back to a public profile after a login or a signup (owner request 2026-11-03: slides on a
// public profile are offered for download only to signed-in visitors, a frontend-only gate, see
// docs/README.md §9.6). Only a profile address is ever followed: /people/{digits}, nothing else, so
// this never changes where any other login or signup lands.
//
// A login carries it in ?redirect= (utils/redirectUtils). A signup cannot: its link arrives by email
// and opens /signup?token= without it. So the signup start keeps the profile address in this browser
// for the life of the link (48 hours, signup.SignupService.TOKEN_HOURS), every start replaces or
// clears it, and a finished signup takes it out again. A link opened in another browser (or a mail
// app's own browser) lands on the own profile as before.
const KEY = 'signupReturnPath';
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

export const profileReturnPath = (value) => (
  typeof value === 'string' && /^\/people\/\d+$/.test(value) ? value : undefined
);

export const rememberSignupReturn = (path) => {
  try {
    if (profileReturnPath(path)) localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
    else localStorage.removeItem(KEY);
  } catch (e) {
    // Storage blocked (private mode): the signup simply ends on the own profile.
  }
};

const read = () => {
  try {
    const { path, at } = JSON.parse(localStorage.getItem(KEY) || 'null') || {};
    return typeof at === 'number' && Date.now() - at <= MAX_AGE_MS ? profileReturnPath(path) : undefined;
  } catch (e) {
    return undefined;
  }
};

// Without removing it: the "you already have an account" step only links to the login.
export const peekSignupReturn = read;

export const takeSignupReturn = () => {
  const path = read();
  try { localStorage.removeItem(KEY); } catch (e) { /* nothing kept */ }
  return path;
};
